import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ExpepharmaLoadingInterceptor } from '@expepharma/services/loading/loading.interceptor';

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ExpepharmaLoadingInterceptor,
            multi: true,
        },
    ],
})
export class ExpepharmaLoadingModule {}
